import { useLocation } from "react-router";
import { Table } from "../../features/Table";
import { type RatingConversion, rating_conversion_columns } from "./columns";
import { FilterRatingConversion } from "./filter";

const client = "instit-quantilia";
const table_name = "rating_conversions";

export const RatingConversionsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<RatingConversion, RatingConversion>
      label="Rating Conversions"
      client={client}
      table_name={table_name}
      columns={rating_conversion_columns}
      filter={<FilterRatingConversion />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
